@if (pendingReplication) {
  <mat-progress-bar [value]="state.percent"></mat-progress-bar>
  <div class="details">
    <div class="data">
      <span>{{ displayPercent() }}%</span>
      <span>
        ({{ displayTotDownloaded() }} / {{ state.totalRemote.toFixed(3) }} {{ "publist.disk.unit" | translate }})
      </span>
    </div>
    <div>
      {{ format(state.eta.getUTCHours()) }}:{{ format(state.eta.getUTCMinutes()) }}:{{
        format(state.eta.getUTCSeconds())
      }}
    </div>
  </div>
}
